
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

function App() {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    // Set document direction based on language
    const isRTL = i18nInstance.language === 'ar';
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18nInstance.language;
    
    // Set default language to Arabic
    if (!i18nInstance.language || i18nInstance.language === 'en') {
      i18nInstance.changeLanguage('ar');
    }
  }, [i18nInstance.language]);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
